import { Quill } from 'react-quill';

const List = Quill.import('formats/list');

export class CustomList extends List {
	static blotName = 'list';

	static create(value: any) {
		const node = super.create(value) as HTMLElement;

		node.setAttribute('style', 'margin: 4px; padding: 4px;');

		return node;
	}
}
